module.exports = __webpack_public_path__ + "static/media/icon-eye-opened.38b439f5.svg";